import Joi from 'joi-full';
import { formValueSelector } from 'redux-form';

import { syncValidateData } from '../../../../common/validator';

const VENDOR_FORM = 'VENDOR_FORM';

const schema = Joi.object().keys({
  enabled: Joi.bool().required(),
  name: Joi.string().min(2).required().label('Vendor name'),
  email: Joi.string().email({ minDomainSegments: 2 }).empty('').required().label('Email'),
});

const validate = values => syncValidateData(values, schema);

export const formConfig = {
  form: VENDOR_FORM,
  validate,
};

export const vendorFormValueSelector = formValueSelector(VENDOR_FORM);
